import axios from "axios";

var Message = {
  initializeHeaders: function (headers) {
    axios.defaults.headers.common = headers;
  },
  get: function () {
    return axios.get(
      Apollo.resolveApiUrl("~/message/"));
  },
  getDetails: function (id) {
    return axios.get(Apollo.resolveApiUrl("~/message/" + id));
  },
  delete: function (id) {
    return axios.delete(Apollo.resolveApiUrl("~/message/" + id));
  },
  create: function (message) {    
    return axios.post(Apollo.resolveApiUrl("~/message/"), message);
  },
  update: function (id) {
    return axios.put(Apollo.resolveApiUrl("~/message/"), { "id": id, "is_active": true });
    },
  getRedirectUrl: function (messageType) {
        return axios.get(Apollo.resolveApiUrl("~/message/GetRedirectUrl"), {
            params: {
                "messageType": messageType
            }
        });
    },

};

export default Message;



// WEBPACK FOOTER //
// ./src/models/Message.js